import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ChatTemplate from '../templates/ChatTemplate';
import SEO from '../atoms/SEO';
import OrbitalCharacterModels from '../molecules/OrbitalCharacterModels';
import { useChat } from '../../context/ChatContext';
import './TechnicalChatPage.css';

const TechnicalChatPage = () => {
  const navigate = useNavigate();
  const { startConversation, conversationStarted, hasTechRequirements, interviewType } = useChat();

  // Redirect to landing page if no technical requirements have been set or wrong interview type
  useEffect(() => {
    if (!hasTechRequirements || interviewType !== 'technical') {
      navigate('/');
    }
  }, [hasTechRequirements, interviewType, navigate]);

  useEffect(() => {
    // Start the conversation if it hasn't started yet
    if (!conversationStarted && hasTechRequirements && interviewType === 'technical') {
      startConversation();
    }
  }, [startConversation, conversationStarted, hasTechRequirements, interviewType]);

  const handleBackClick = () => {
    navigate('/');
  };

  // Define the 3D models to display (using same models as regular chat)
  const characterModels = [
    { 
      src: '/models/ni.glb', 
      character: '你',
      customOrbit: {
        size: 500,
        duration: 95,
        modelSize: 300
      }
    },
    { src: '/models/hao.glb', character: '好' },
    { src: '/models/zhong.glb', character: '中' },
    { 
      src: '/models/wen.glb', 
      character: '文',
      customOrbit: {
        size: 550,
        duration: 75,
        modelSize: 180
      }
    }
  ];

  // If no technical requirements are loaded, don't render the page (will redirect)
  if (!hasTechRequirements || interviewType !== 'technical') {
    return null;
  }

  return (
    <div className="technical-chat-page">
      <SEO 
        title="Technical Interview" 
        description="Practice technical interviews with our AI Senior Software Engineer" 
      />
      
      <div className="chat-container">
        <ChatTemplate 
          onBackClick={handleBackClick} 
          interviewerName="Senior Software Engineer"
        />
      </div>
      
      {/* 3D Character Models */}
      <OrbitalCharacterModels models={characterModels} />
    </div>
  );
};

export default TechnicalChatPage; 